import { AutoMap } from "@automapper/classes";

export class Competence {
    @AutoMap()
    Name!: string;
}